/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

import axios from "axios";
import moment from "moment-timezone";

import {
  getUser,
  setUserSession,removeUserSession,
  getTokenExpires,
  setTokenExpires,
  getusRetailerSession,
  getusRetailerLoginSession,
  usRetailerSession,
  usRetailerLoginSession
} from "../utils/UserDetails";
import jwtDecode from "jwt-decode";

const baseURL = `${process.env.REACT_APP_BACKEND_BASEURL}api`;
const headerData = {
  'Accept': 'application/json',
  'ctz': moment.tz.guess()
};

const currentUser = getUser();
let isRefresh = 1;
let currentTime = moment().tz("UTC").unix();
let token = getUser();
let isTokenExpiredData = null;
let isTokenExpired = null;
let callOut = null;
let originalRequest = null;

if (currentUser) {
    headerData.Authorization = `Bearer ${currentUser.api_token}`
  }
  const axiosInstance = axios.create({
      baseURL: baseURL,
      headers: headerData
  });

  axiosInstance.interceptors.request.use(async (config) => {
     token = getUser();
     originalRequest = config;

  if(token) {
    const { exp } = jwtDecode(token)

    // Refresh the token a minute early to avoid latency issues
   const expirationTime = (exp * 1000) - (60 * 30 * 1000)

    if (Date.now() >= expirationTime) {

      await axios({ method: 'get', url: `${baseURL}/refresh-token`, headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      } }).then((result) => {
        token = result.data.access_token;
        setUserSession(result.data.access_token,result.data.expires_in)
        
          setTimeout(() => {
            if(getusRetailerSession()) {
              usRetailerSession()
            }
            if(getusRetailerLoginSession()) {
              usRetailerLoginSession()
            }
          }, 1000);

      }).catch((error) => {
        console.log(error)
      });
    }
  }
    originalRequest.headers.Authorization = `Bearer ${token}`;
    return originalRequest;
  
  }, (err) => {
    console.log("error in getting ", err)
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
  
      if (error.response.status === 401) {
        removeUserSession();
        window.location.href = '/';
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  );


  
  export default axiosInstance;